import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { authType } from "../../../../../pages/Login";
import LineBtn from "../../../../Button/LineBtn";
import GradeDeleteModal from "../GradeAddModal/GradeDeleteModal";

export default function GradeDeleteBtn() {
  const auth = useRecoilValue(authType);

  const [gradeDeleteModal, setGradeDeleteModal] = useState(false);

  return (
    <>
      <LineBtn
        btnText="등급 삭제"
        btnHeight={38}
        btnClickEvent={() => setGradeDeleteModal(true)}
        disabled={!auth?.adminSet}
      />

      {gradeDeleteModal && (
        <GradeDeleteModal closeEvent={() => setGradeDeleteModal(false)} />
      )}
    </>
  );
}
